export const MATCH_START: string = '10'
export const MATCH_END: string = '20'
export const PERIOD_START: string = '24'

export const FIRST_SET: string = '35'
export const SECOND_SET: string = '36'
export const THIRD_SET: string = '37'

export const INITIALLY_SERVING_PLAYER: string = '1022'
export const SCORE_CHANGE_TENNIS: string = '1025'
